import React, { createContext, useContext, useEffect, useMemo } from 'react';

const STORAGE_KEY = 'erp-color-theme';

/** Dark mode is disabled until styles are fully aligned. */
export const DARK_MODE_ENABLED = false;

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    try {
      localStorage.setItem(STORAGE_KEY, 'light');
    } catch {
      /* ignore */
    }
  }, []);

  const value = useMemo(
    () => ({
      theme: 'light',
      isDark: false,
      darkModeEnabled: DARK_MODE_ENABLED,
      toggleTheme: () => {},
      setTheme: () => {},
    }),
    []
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return ctx;
}
